




























































































































import {Component, PropSync} from "vue-property-decorator";
import {Action, Getter} from "vuex-class";
import BaseFilter from "@/components/Filter/BaseFilter";
import {ProviderConnectionFilter} from "@/store/settings/provider_connections/types";
import {SelectWings} from "wings-ui-components";
import axios from "axios";
import {ActionLog} from "@/store/auth/types";

@Component({components: {SelectWings}})
export default class ProviderConnectionsFilter extends BaseFilter<ProviderConnectionFilter>{
  @PropSync('show') is_show!: boolean;
  @Action("getProviderConnections") actionGetProviderConnections: any;
  @Action("actionLog") actionLog: any;
  @Getter("providerConnectionStatus") providerConnectionStatus:any;

  defaultFilter(): ProviderConnectionFilter {
    return {
      name: undefined,
      server_name: undefined,
      status: undefined,
    }
  }

  created() {
    this.filtered();
  }

 async onFilteredAction() {
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Service provider's connection",
        addititional_info: this.filter
      };
      await this.actionGetProviderConnections(this.filter);
      await this.actionLog(this.logObject);
    } catch (err){
      await this.actionLog({...this.logObject, action_status: "failed"});
    }
  }
}
